import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var fakeCursorForToolbarPluginKey = new PluginKey('fakeCursorToolbarPlugin');